import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SessionAuth, useSessionContext } from 'supertokens-auth-react/recipe/session';
import { getAdminViewerRegionDebug } from '../apiClient';

const AdminContent = () => {
  const session = useSessionContext();
  const navigate = useNavigate();
  const [regionDebug, setRegionDebug] = useState(null);
  const [debugLoading, setDebugLoading] = useState(false);
  const [debugError, setDebugError] = useState('');

  // Basic Role Check
  if (session.loading) return null;

  const roles = session.accessTokenPayload && session.accessTokenPayload["st-role"]?.v;
  const isAdmin = roles && roles.includes("admin");

  if (!isAdmin) {
    return (
      <div className="container mx-auto p-4 text-center mt-10">
        <h1 className="text-2xl font-bold text-red-600">Access Denied</h1>
        <p className="text-gray-600 mt-2">You do not have permission to view this page.</p>
        <Link to="/" className="text-blue-500 hover:underline mt-4 block">Go Home</Link>
      </div>
    );
  }

  const handleLoadRegionDebug = async () => {
    try {
      setDebugLoading(true);
      setDebugError('');
      const payload = await getAdminViewerRegionDebug();
      setRegionDebug(payload);
    } catch (err) {
      console.error('Error loading viewer-region debug:', err);
      setDebugError('Failed to load region debug data.');
    } finally {
      setDebugLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Admin Dashboard</h1>
      <div className="flex justify-center flex-wrap gap-4">
        <Link to="/admin/roles" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md">
          Manage Roles
        </Link>
        <Link to="/admin/user-credits" className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-2 px-4 rounded-md">
          User Credits (Image Gen)
        </Link>
        <Link to="/admin/scheduler-status" className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md">
          Scheduler Status
        </Link>
      </div>

      <div className="max-w-3xl mx-auto mt-8 bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <h2 className="text-lg font-semibold text-gray-800">Catalog Region Debug</h2>
          <button
            type="button"
            onClick={handleLoadRegionDebug}
            disabled={debugLoading}
            className="bg-slate-700 hover:bg-slate-800 disabled:opacity-60 text-white text-sm font-semibold py-2 px-3 rounded-md"
          >
            {debugLoading ? 'Loading...' : 'Load viewer region'}
          </button>
        </div>
        <p className="text-sm text-gray-600 mt-2">
          Uses admin-only endpoint <code>/admin/debug/viewer-region</code>.
        </p>
        {debugError && <p className="text-sm text-red-600 mt-3">{debugError}</p>}
        {regionDebug && (
          <pre className="mt-3 text-xs bg-gray-50 border border-gray-200 rounded-md p-3 overflow-auto whitespace-pre-wrap break-all">
            {JSON.stringify(regionDebug, null, 2)}
          </pre>
        )}
      </div>
    </div>
  );
};

const AdminPage = () => {
  return (
    <SessionAuth>
      <AdminContent />
      {/* sdkdsfjkl */}
    </SessionAuth>
  );
};

export default AdminPage;
